export const namespace = __NAMESPACE__;
export const version = __SDK_VERSION__;
export const env = process.env.NODE_ENV;
